export default function dateUtils(): any {
  const dateStringToIsoDate = (datum: string): Date | undefined => {
    const dateFromString = new Date(datum + "T12:00:00");
    const isValidDate = Boolean(+dateFromString);
    return isValidDate ? dateFromString : undefined;
  };

  const dateStringToLocalDate = (datum: string): string | undefined => {
    const date = dateStringToIsoDate(datum);
    if (!date) {
      return undefined;
    }

    return getLocalDate(date);
  };

  const getLocalDate = (date: Date): string => {
    if (date === undefined) {
      return "";
    }
    return date.toLocaleDateString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const getIsoDate = (date: Date): string => {
    const offset = date.getTimezoneOffset();
    const iso = new Date(date.getTime() - offset * 60 * 1000).toISOString();
    return iso.substring(0, iso.indexOf("T"));
  };

  const getIsoDateNow = (): string => {
    const date = getNow();
    return getIsoDate(date);
  };

  const getNow = (): Date => {
    return new Date(getIsoDate(new Date()));
  };

  const getNowWithTime = (): Date => {
    return new Date(new Date().toISOString());
  };

  const getIsoDateNowPlus = (tage: number): string => {
    const date: Date = getNow();
    date.setDate(date.getDate() + tage);
    return getIsoDate(date);
  };

  const pruefeNach12Uhr = (): boolean => {
    const date: Date = getNowWithTime();
    return date.getHours() >= 12;
  };

  const pruefe2902 = (): boolean => {
    const date: Date = getNow();
    return date.getDate() == 29 && date.getMonth() == 1;
  };

  const korrektur2902 = (datum: Date): Date => {
    if (datum.getMonth() === 1 && datum.getDate() === 29) {
      datum = new Date(datum.getFullYear() + "-03-01");
    }

    return datum;
  };

  const getIsoDatePlusYears = (years: number): string => {
    const date = getNow();
    const nextYear = date.getFullYear() + years;
    date.setFullYear(nextYear);
    return getIsoDate(date);
  };

  const getIsoDatePlusYearsPlusMonths = (years: number, months: number): string => {
    const date = new Date(getIsoDatePlusYears(years));
    const nextMonth = date.getMonth() + months;
    date.setMonth(nextMonth);
    return getIsoDate(date);
  };

  const getDatumAlsISOString = (mitUhrzeit = false, mitMillisekunden = false, datum = getNow()): string => {
    if (!mitUhrzeit) {
      return datum.toISOString().split("T")[0];
    }
    return mitMillisekunden ? datum.toISOString() : datum.toISOString().split(".")[0];
  };

  const getAlterZuStichtag = (geburtsdatum: string, stichtag: string): number | undefined => {
    const geburtsdatumDate = dateStringToIsoDate(geburtsdatum);
    const stichtagDate = dateStringToIsoDate(stichtag);

    if (geburtsdatumDate && stichtagDate) {
      let alter = stichtagDate.getFullYear() - geburtsdatumDate.getFullYear();
      const m = stichtagDate.getMonth() - geburtsdatumDate.getMonth();
      if (m < 0 || (m === 0 && stichtagDate.getUTCDate() < geburtsdatumDate.getUTCDate())) {
        alter--;
      }

      return alter;
    }
    return undefined;
  };

  const splitDate = (date: Date) => {
    return splitDateString(getIsoDate(date));
  };

  const splitDateString = (date: string) => {
    const split = date.split("-");
    const jahr = parseInt(split[0]);
    const monat = parseInt(split[1]);
    const tag = parseInt(split[2]);

    return { jahr, monat, tag };
  };

  return {
    dateStringToIsoDate,
    dateStringToLocalDate,
    getLocalDate,
    getIsoDate,
    getIsoDateNow,
    getIsoDateNowPlus,
    pruefeNach12Uhr,
    pruefe2902,
    getAlterZuStichtag,
    getDatumAlsISOString,
    splitDateString,
    splitDate,
    getNow,
    getNowWithTime,
    korrektur2902,
    getIsoDatePlusYears,
    getIsoDatePlusYearsPlusMonths,
  };
}
